<template>
    <div class="custom-control custom-switch sw-min-form">
      <input type="checkbox" name="check-basico"  autocomplete="off" class="custom-control-input"   id="aflnuevaBasico" @change="changeCrud({state: 'minform',boolean: ''})">
      <label class="custom-control-label" for="aflnuevaBasico" style="cursor:pointer"> Minimizar formulario</label>
    </div> 
</template>
<script>
export default 
{
  name: 'swminform',
}
</script>
<style lang="stylus">
.sw-min-form{
  position: absolute;
  top: -25px;
  height: 25px;
  width:100%
}
</style>